import{m as h}from"./chunk-HBP5N4FR.js";h();var a=s=>{let t=window==null?void 0:window.location.hash;return t.substring(0,t.indexOf("/")>0?t.indexOf("/"):t.length).replace("#","")===s};export{a};
//# sourceMappingURL=chunk-I2ACNKBY.js.map
